"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrapiClient = exports.createClient = void 0;
const strapi_client_1 = require("./lib/strapi-client");
Object.defineProperty(exports, "StrapiClient", { enumerable: true, get: function () { return strapi_client_1.StrapiClient; } });
const defaultOptions = {
    url: '',
    normalizeData: true,
};
/**
 * Strapi Client Options Object
 *
 * @param url Strapi application url
 *
 * @param apiToken Authorized Api Token
 *
 * @param normalizeData Disables Unified response format. default - true
 *
 * @param headers custom headers
 *
 * @param debug Query log on development. default - false
 *
 * @param persistSession Using browser localstorage to save the current session. default- flase
 *
 */
const createClient = (options) => {
    return new strapi_client_1.StrapiClient(Object.assign(Object.assign({}, defaultOptions), options));
};
exports.createClient = createClient;
